<template>
    <div class="con">
        <div class="banner">
            <img src="../assets/zy/hbanner.png" alt="">
            <img src="../assets/zy/hbanner2.png" alt="">
        </div>
        <div class="main">
            <div class="intro">
                 <div class="left wow">
                  <p class="title">{{$t('sale').text0}}</p>
                    <div class="content">
                        <p>{{$t('sale').text1}}<br>
                            {{$t('sale').text2}}</p>
                        <saleDia />
<!--                            <p>-->

<!--                                {{$t('sale').text3[0]}}<br>-->
<!--                                <br>-->
<!--                                {{$t('sale').text3[1]}}<br>-->
<!--                                <br>-->
<!--                                {{$t('sale').text3[2]}}-->

<!--                            </p>-->
                    </div>
                 </div>
                <div class="right wow">
                    <img src="../assets/zy/sr.png" alt="">
                </div>
            </div>
            <div class="tech">
            <div class="left wow">
                <img src="../assets/zy/sl.png" alt="">
            </div>
                <div class="right wow fadeInRight">
                    <p class="title">{{$t('sale').text4}}</p>
                    <p class="title2">{{$t('sale').text5}}</p>
                    <div class="allCon wow fadeInUp">
                        <el-collapse  v-model="activeNames" accordion>
                            <el-collapse-item v-for="(item,index) in list" :key="index" name="1">
                                <template slot="title">
                                    <div class="aTitle">
                                        <span class="aText">{{ item.title}}</span>
                                        <div class="lines">
                                            <span></span><span></span>
                                        </div>
                                    </div>
                                </template>
                                <div class="aInfo">
                                    <div class="info1">
                                        <div class="memo">
                                            <p v-html="item.description"></p>
                                        </div>
                                    </div>
                                </div>
                            </el-collapse-item>
                        </el-collapse>
                    </div>
                </div>
            </div>
        </div>
        <foot-Component></foot-Component>
    </div>
</template>

<script>
    import footComponent from '../components/foot'
    import saleDia from '../components/saleDia'
    import Scrollbar from 'smooth-scrollbar'
    import {getProductsUrl} from '../util/lang'
    export default {
        name: 'about',
        data(){
            return{
                list:[],
                activeNames: ['1']
            }
        },
        components:{footComponent,saleDia},
        mounted() {
            Scrollbar.initAll(document.getElementById("scroller-wrapper"));
            this.scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
            this.scrollbar.scrollTo(0,1)
            this.scrollbar.addListener((status) => {
                window.pageYOffset=this.scrollbar.scrollTop
            });
            this.$nextTick(()=>{
                if(this.$i18n.locale==='en'){
                    this.getList('114')
                }else{
                    this.getList('14')
                }

            })
        },
        methods:{
            getList(id){
                const url = `${getProductsUrl(id)}`
                this.$axios.get(url).then(res => {
                    this.list=res.data.data
                    console.log(this.list)
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .con{
        width:100%;
        animation: run5 1s linear forwards;
        position: relative;
        @keyframes run5 {
            from{
                opacity: 0;
            }
            to{
                opacity: 1;
            }
        }
        .banner{
            width:100%;
            position: relative;
            overflow: hidden;
            img{
                display: block;
                width:100%;
                object-fit: cover;
                animation: sbig 2s linear forwards;
            }
            img:nth-child(2){
                display: none;
            }
            @keyframes sbig {
                from{
                    transform: scale(1);
                    filter: blur(5px);
                }
                to{
                    transform: scale(1.05);
                    filter: blur(0);
                }
            }
        }
        .main{
            width:1440px;
            margin: 60px auto;
            .intro{
                width:100%;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                .left{
                    width:42%;
                    z-index: 100;
                    animation:transition1 1s  forwards linear  ;
                    .title{
                        width:100%;
                        font-size: 26px;
                        color:#333333;
                        font-family: "SourceHanSansSC-Regular";
                        display: flex;
                        flex-direction: column;
                        &::after{
                            content:'';
                            display: inline-block;
                            height:5px;
                            width:47px;
                            background-color: #FDCC49;
                            margin-top: 20px;
                        }
                    }
                    .content{
                        width:120%;
                        background-color: #FCFCF9;
                        padding: 60px 0;
                        margin: 40px auto;
                        p:nth-child(1){
                            font-size: 16px;
                            font-weight: 600;
                            color: #666666;
                            margin-bottom: 20px;
                        }
                        p{
                            width:80%;
                            margin: 0 auto;
                            color:#919191;
                            line-height: 30px;
                            font-size: 14px;
                            font-family: "SourceHanSansSC-Regular";
                        }
                    }
                }
                .right{
                    width:58%;
                    overflow: hidden;
                    cursor: pointer;
                    animation:transition2 1s  forwards linear  ;
                    z-index: 10;
                    img{
                        width:100%;
                        display: block;
                        object-fit: cover;
                        transition: all 600ms;
                    }
                    &:hover{
                        img{
                            transform: scale(1.2);
                        }
                    }
                }
            }
            .tech{
                width:80%;
                margin: 120px auto;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                .left{
                    width:40%;
                    overflow: hidden;
                    cursor: pointer;
                    animation:polygon 1s  forwards linear  ;
                    img{
                        width:100%;
                        display: block;
                        object-fit: cover;
                        transition: all 600ms;
                    }
                    &:hover{
                        img{
                            transform: scale(1.1);
                        }
                    }
                }
                .right{
                    width:55%;
                    .title{
                        width:100%;
                        font-size: 26px;
                        color:#333333;
                        font-family: "SourceHanSansSC-Regular";
                        display: flex;
                        flex-direction: column;
                        &::after{
                            content:'';
                            display: inline-block;
                            height:5px;
                            width:47px;
                            background-color: #FDCC49;
                            margin-top: 20px;
                        }
                    }
                    .title2{
                        font-size: 14px;
                        line-height: 30px;
                       margin-top: 30px;
                    }
                    .allCon{
                        width:100%;
                        margin: 60px auto;
                        .aTitle{
                            width:100%;
                            display: flex;
                            flex-direction: row;
                            background-color: #F7F7F7;
                            justify-content: space-between;
                            align-items: center;
                            .aText{
                                display: inline-block;
                                width:80%;
                                color:#585858;
                                transition: all 600ms;
                                margin-left: 5%;
                                font-size: 16px;
                            }
                            .lines{
                                width:15px;
                                height:15px;
                                margin-right: 5%;
                                position: relative;
                                span{
                                    display: inline-block;
                                    position: absolute;
                                }
                                span:nth-child(1){
                                    width:1px;
                                    height:100%;
                                    left:7px;
                                    top:0;
                                    background-color: black;
                                    transition: all 600ms;
                                }
                                span:nth-child(2){
                                    height:1px;
                                    width:100%;
                                    top:7px;
                                    left:0;
                                    background-color: black;
                                }
                            }
                        }
                        .aTitle:hover .aText{
                            color:#FECD4A;
                        }
                        .aTitle:hover .lines{
                            span:nth-child(1){
                                transform: rotate(90deg);
                            }
                        }
                        .aInfo{
                            width:90%;
                            margin: 0 auto;
                            background-color: white;
                            .info1{
                                margin: 20px auto;
                                .memo{
                                    line-height: 30px;
                                    color:#666666;
                                    font-family: "SOURCEHANSANSCN-LIGHT";
                                    font-size: 14px;
                                }
                            }
                            .aBtn{
                                width:100%;
                                text-align: right;
                                margin-top: 30px;
                                span{
                                    display: inline-block;
                                    padding: 5px 40px;
                                    cursor: pointer;
                                    border: 1px solid #E5E5E5;
                                    transition: all 2s;
                                    font-size: 14px;
                                }
                                span:hover{
                                    background-color: #0A9EB0;
                                    color:white;
                                }
                            }
                        }
                    }
                }
            }
        }
        .foot{
            animation-name: polygon;
            animation-duration: 2s;
        }
        @keyframes transition1 {
            0% {
                transform: translate(-300px,-300px);
                opacity: 0;
            }
            100% {
                transform: translate(0,0);
                opacity: 1;
            }
        }
        @keyframes transition2 {
            0% {
                transform: translate(300px,-300px);
                opacity: 0;
            }
            100% {
                transform: translate(0,0);
                opacity: 1;
            }
        }
        @keyframes polygon {
            0% {
                clip-path: polygon(0 0,0 100%,0 100%,0 0);
                opacity: 0;
            }
            100% {
                clip-path: polygon(0 0,0 100%,100% 100%,100% 0);
                opacity: 1;
            }
        }
        @media screen and (max-width: 1440px){
            .main{
                width:90%;
                .ncenter{
                    .allItems{
                        .item{
                            .r{
                                p:nth-child(1){
                                    margin: 10px auto;
                                }
                            }
                        }
                    }
                }
            }
        }
        @media screen and (max-width: 1000px){
            .banner{
                img{
                    height:500px;
                }
                img:nth-child(1){
                    display: none;
                }
                img:nth-child(2){
                    display: inline-block;
                }
                .text{
                    bottom:20%;
                    p:nth-child(1){
                        font-size: 30px;
                    }
                    p:nth-child(2){
                        font-size: 16px;
                    }
                }
            }
            .main{
                .intro{
                    flex-direction: column;
                    .left,.right{
                        width:100%;
                        margin-left: 0;
                    }
                    .left{
                        .content{
                            width:100%;
                        }
                    }
                }
                .tech{
                    margin: 30px auto;
                    width:100%;
                    flex-direction: column-reverse;
                    .left,.right{
                        width:100%;
                    }
                    .right{
                        margin-top: 30px;
                        .allCon{
                            .aTitle{
                                .aText{
                                        font-size: 14px;
                                    display: -webkit-box;
                                    -webkit-box-orient: vertical;
                                    -webkit-line-clamp: 1;
                                    overflow: hidden;
                                    height:50px;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>
<style scoped>
    .allItems .swiper-pagination>>>.swiper-pagination-bullet {
        width:5px;
        height:5px;
        background:rgba(83,83,83,1);
        border-radius:50%;
        margin-left: 30px;
        position: relative;
    }
    .allItems .swiper-pagination>>>.swiper-pagination-bullet::before{
        content:'';
        width:15px;
        height:15px;
        border:1px solid rgba(83,83,83,1);
        border-radius:50%;
        display: inline-block;
        position: absolute;
        left:-6px;
        top:-6px;
        opacity: 0;
        transition: all 600ms;
    }
    .allItems .swiper-pagination>>>.swiper-pagination-bullet-active::before{
        opacity: 1;
    }
</style>
